/* AUTH ACTIONS */
export const AUTH_LOGIN = "auth_login";
export const AUTH_LOGOUT = "auth_logout";
export const AUTH_REFRESH = "auth_refresh";
export const AUTH_ERROR = "auth_error";
export const AUTH_FETCHING_DATA = "auth_fetching_data";

/* GENERIC ACTIONS AEDOLIST */
export const LIST_INDEX = "list_index";
export const LIST_SHOW = "list_show";
export const LIST_GET_COMPANY = "list_get_company";
export const LIST_CREATE = "list_create";
export const LIST_EDIT = "list_edit";
export const LIST_GET_NEW_DATA = "list_get_new_data";
export const LIST_FETCHING_DATA = "list_fetching_data";
export const LIST_ERROR = "list_error";
export const LIST_CHANGE_ACTIVE_FILTER_STATUS =
  "list_change_active_filter_status";
export const LIST_GET_OPENED = "list_get_opened";
export const LIST_OPEN = "list_open";
export const LIST_CLOSE = "list_close";
export const LIST_SELECT = "list_select";
export const LIST_PROGRESS = "list_progress";
export const LIST_CLEAR_SELECTED_ROW = "list_clear_selected_row";

/* PROJECT ACTIONS */
export const PROJECT_INDEX = "project_index";
export const PROJECT_SHOW = "project_show";
export const PROJECT_GET_COMPANY = "project_get_company";
export const PROJECT_CREATE = "project_create";
export const PROJECT_EDIT = "project_edit";
export const PROJECT_GET_NEW_DATA = "project_get_new_data";
export const PROJECT_FETCHING_DATA = "project_fetching_data";
export const PROJECT_ERROR = "project_error";
export const PROJECT_CHANGE_ACTIVE_FILTER_STATUS =
  "project_change_active_filter_status";
export const PROJECT_GET_OPENED = "project_get_opened";
export const PROJECT_OPEN = "project_open";
export const PROJECT_CLOSE = "project_close";
export const PROJECT_SELECT = "project_select";
export const PROJECT_PROGRESS = "project_progress";

/* PROJECT DETAILS ACTIONS */
export const PROJECT_DETAILS_EDIT_STAGE_DATA = "project_edit_stage";
export const PROJECT_DETAILS_GET_STAGE_DATA = "project_details_get_stage_data";
export const PROJECT_DETAILS_FETCHING_DATA = "project_details_fetching_data";
export const PROJECT_DETAILS_ERROR = "project_details_error";
export const PROJECT_DETAILS_ADD_STAGE = "project_details_add_stage";
export const PROJECT_DETAILS_REMOVE_STAGE = "project_details_remove_stage";
export const PROJECT_DETAILS_STAGE_ADD_POINT =
  "project_details_stage_add_point";
export const PROJECT_DETAILS_STAGE_UPLOAD_CSV =
  "project_details_stage_upload_csv";
export const PROJECT_DETAILS_STAGE_UPDATE_POINT =
  "project_details_stage_update_point";
export const PROJECT_DETAILS_STAGE_REMOVE_POINT =
  "project_details_stage_remove_point";
export const PROJECT_DETAILS_TOGGLE_POINT_SELECT =
  "project_details_toggle_point_select";
export const PROJECT_DETAILS_GET_POINT_DATA = "project_details_get_point_data";
export const PROJECT_DETAILS_GET_POINT_NOTES =
  "project_details_get_point_notes";
export const PROJECT_DETAILS_ADD_POINT_NOTE = "project_details_add_point_note";
export const PROJECT_DETAILS_UNSET_POINT_DATA =
  "project_details_unset_point_data";
export const PROJECT_CLEAR_SELECTED_PROJECT = "project_clear_selected_project";

export const ISSUE_SELECTED = "issue_selected";
export const ATTACHMENT_CREATE = "attachment_create";

/* USERS ACTIONS */
export const USERS_INDEX = "users_index";
export const USERS_CREATE = "users_create";
export const USERS_EDIT = "users_edit";
export const USERS_SHOW = "users_show";
export const USERS_FETCHING_DATA = "users_fetching_data";
export const USERS_ERROR = "users_error";

/* COMPANIES ACTIONS */
export const COMPANY_CREATE_CONTACT = "create_contact_cmp";
export const COMPANY_EDIT_CONTACT = "edit_contact_cmp";
export const COMPANY_GET_CONTACTS = "get_contacts_cmp";
export const COMPANY_DELETE_CONTACTS = "delete_contacts_cmp";

export const COMPANY_GET_PROJECTS = "company_get_projects";

export const COMPANIES_INDEX = "companies_index";
export const COMPANIES_SHOW = "companies_show";
export const COMPANIES_CREATE = "companies_create";
export const COMPANIES_EDIT = "companies_edit";
export const COMPANIES_GET_NEW_DATA = "companies_get_new_data";
export const COMPANIES_FETCHING_DATA = "companies_fetching_data";
export const COMPANIES_ERROR = "companies_error";
export const COMPANIES_CHANGE_ACTIVE_FILTER_STATUS =
  "companies_change_active_filter_status";

/* SEARCHING ACTIONS */
export const SEARCHING = "searching";
export const SEARCHING_FETCHING_DATA = "searching_fetching_data";
export const SEARCHING_ERROR = "searching_error";

/* CALCULATIONS ACTIONS */
export const CALCULATION_FETCHING_DATA = "calculation_fetching_data";
export const CALCULATION_GET = "calculation_get";
export const CALCULATION_GET_FOR_SELECTED_PROJECT =
  "calculation_get_for_selected_project";
export const CALCULATION_CREATE = "calculation_create";
export const CALCULATION_SAVE = "calculation_save";
export const CALCULATION_COPY = "calculation_copy";
export const CALCULATION_DELETE = "calculation_delete";
export const CALCULATION_ERROR = "calculation_error";
export const CALCULATION_ADD_ROW = "calculation_add_row";
export const CALCULATION_DELETE_ROW = "calculation_delete_row";
export const CALCULATION_REMOVE_ROW = "calculation_remove_row";
export const CALCULATION_MOVE_ROW = "calculation_move_row";
export const CALCULATION_INSERT_ROWS = "calculation_insert_rows";
export const CALCULATION_GET_NORM_SETS = "calculation_get_norm_sets";
export const UPDATE_NORM_SETS = "update_norm_sets";
export const SET_ACTIVE_NORMSET = "set_active_normset";
export const SET_DATA_SELECTED_CALCULATION = "set_data_selected_calculation";
export const CALCULATION_GET_ARTICLES = "calculation_get_articles";
export const UPDATE_ARTICLES = "update_articles";
export const SET_ACTIVE_ARTICLE = "set_active_article";
export const SET_ACTIVE_LABOR = "set_active_labor";
export const SET_ACTIVE_MEASUREMENT_STATE = "set_active_measurement_state";
export const CALCULATION_INSERT_MEASUREMENT_STATE =
  "calculation_insert_measurement_state";
export const CALCULATION_SELECT_CALCULATION = "calculation_select_calculation";
export const CALCULATION_UPDATE = "calculation_update";
export const CALCULATION_UPDATE_CALCULATION_DATA =
  "calculation_update_calculation_data";
export const CALCULATION_SET_DIRTY = "calculation_set_dirty";

/* CALCULATION GRID ACTIONS */
export const CALCULATION_CREATE_OFFER = "calculation_create_offer";

/* EXPLORER FS ACTIONS */
export const EXPLORER_LIST = "explorer_list";
export const EXPLORER_FETCH_DATA = "explorer_fetch_data";
export const EXPLORER_FETCH_GET_DATA = "explorer_fetch_get_data";

/* INVOICES ACTIONS */
export const FINANCE_PURCHASING_INVOICE_FETCHING_DATA =
  "finance_purchasing_invoice_fetching_data";
export const FINANCE_PURCHASING_INVOICE_GET_DATA =
  "finance_purchasing_invoice_get_data";
export const FINANCE_PURCHASING_INVOICE_ERROR =
  "finance_purchasing_invoice_error";
export const FINANCE_UPDATE_LINKS = "finance_update_links";
export const FINANCE_PURCHASING_INVOICE_SAVE =
  "finance_purchasing_invoice_save";
export const FINANCE_PURCHASING_INVOICE_SAVE_IN_PROGRESS =
  "finance_purchasing_invoice_save_in_progress";
export const FINANCE_PURCHASING_INVOICE_ITEM_CREATE =
  "finance_purchasing_invoice_item_create";
export const FINANCE_PURCHASING_INVOICE_ITEM_SAVE =
  "finance_purchasing_invoice_item_save";
export const FINANCE_PURCHASING_INVOICE_ITEM_DELETE =
  "finance_purchasing_invoice_item_delete";
export const FINANCE_PURCHASING_INVOICE_ITEM_SAVE_IN_PROGRESS =
  "finance_purchasing_invoice_item_save_in_progress";
export const FINANCE_PURCHASING_INVOICE_CHECK_APPROVABLE =
  "finance_purchasing_invoice_check_approvable";
export const FINANCE_PURCHASING_INVOICE_APPROVE =
  "finance_purchasing_invoice_approve";
export const FINANCE_PURCHASING_INVOICE_DISAPPROVE =
  "finance_purchasing_invoice_disapprove";
export const FINANCE_PURCHASING_INVOICE_APPROVE_IN_PROGRESS =
  "finance_purchasing_invoice_approve_in_progress";
export const FINANCE_PURCHASING_INVOICE_SHOW_ACCEPTED =
  "finance_purchasing_invoice_show_accepted";

/* WORKTIME ACTIONS */
export const WORKTIME_CURRENT_WEEK_DATA = "worktime_current_week_data";
export const WORKTIME_FETCHING_DATA = "worktime_fetching_data";
export const WORKTIME_ERROR = "worktime_week_error";
export const WORKTIME_UPDATE_DATA = "worktime_update_data";
export const WORKTIME_POST = "worktime_post";
export const WORKTIME_HISTORY = "worktime_history";
export const WORKTIME_ISEMPTY = "worktime_isempty";
export const WORKTIME_ADD_NEW_LOG = "worktime_add_new_log";
export const WORKTIME_REMOVE_LOG = "worktime_remove_log";

/* WORKTIME APPROVAL ACTIONS */
export const WORKLOG_REPORTS_WEEK_SELECTED = "worklog_reports_week_selected";
export const WORKLOG_REPORTS_VIEW_DATA = "worklog_reports_view_data";
export const WORKLOG_REPORTS_WEEK_APPROVED = "worklog_reports_week_approved";
export const WORKLOG_REPORTS_WEEK_REJECTED = "worklog_reports_week_dispproved";
export const WORKLOG_REPORTS_DEFAULT_PROJECT_DATA =
  "worklog_reports_default_project_data";

/* APP ACTIONS */
export const APP_SIDEBAR_ITEMS = "app_sidebar_items";
export const APP_ERROR = "app_error";
export const APP_SIDEBAR_FETCHING_ITEMS = "app_sidebar_fetching_items";
export const APP_GET_CURRENT_USER = "app_get_current_user";
export const APP_GET_ALL_USERS = "app_get_all_users";
export const APP_SIDEBAR_STATE = "app_set_sidebar_state";

/* ALL PURCHASING INVOICES */
export const FINANCE_ALL_PURCHASING_INVOICES_INDEX =
  "finance_all_purchasing_invoices_index";
export const FINANCE_ALL_PURCHASING_INVOICES_GET_NEW_DATA =
  "finance_all_purchasing_invoices_get_new_data";
export const FINANCE_ALL_PURCHASING_INVOICES_ERROR =
  "finance_all_purchasing_invoices_error";
export const FINANCE_ALL_PURCHASING_INVOICES_FETCHING_DATA =
  "finance_all_purchasing_invoices_fetching_data";

/* OFFER ACTIONS */
export const OFFER_INDEX = "offer_index";
export const OFFER_FETCHING_DATA = "offer_fetching_data";
export const OFFER_ERROR = "offer_error";

/* BIM ACTIONS */
export const BIM_VIEW = "bim_view";
export const BIM_LIST = "bim_list";
export const BIM_LOGIN = "bim_login";
export const BIM_ERROR = "bim_error";
export const BIM_BUCKET_DETAILS = "bim_bucket_created";
export const BIM_VIEWER_SELECT_OBJECT = "bimviewerselectoobject";
export const BIM_FOLDERS_ITEMS = "bim_folder_items";
export const BIM_PROJECTS = "bim_projects";
export const BIM_LOADING = "bim_loading";
export const BIM_ADD_STACK = "bim_add_stack";
export const BIM_POP_STACK = "bim_pop_stack";

/* BIM ISSUE ACTIONS */
export const ISSUE_CREATE = "issue_create";
export const ISSUE_EDIT = "issue_edit";
export const ISSUE_SELECT = "issue_select";
export const ISSUE_FIND_USER = "find_user";
export const BIM_GET_ALL_ISSUES = "bim_get_all_issues";

/* BIM MEASUREMENT ACTIONS */
export const MEASUREMENT_SELECT = "measurement_select";
